import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { passengerCMSApi } from "~/Services";

interface DocumentDetailsResponse {
  parent_term_id: string;
  id: string;
  name: string;
  title_malay: string;
  title_mandarin: string;
  published: boolean;
}

// edit api call
const fetchParentAirportDetails = async (parent_term_id: string): Promise<any> => {
  if (!parent_term_id) {
    return null;
  }
  const response: any = await passengerCMSApi.get(`/api/get-airport-category-crud-api-data/${parent_term_id}`);
  console.log(response.data.data, "testtttt");
  return response?.data.data;
};

const useParentAirportDocumentDetails = (
  parent_term_id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["levelDocumentDetails", parent_term_id],
      enabled: false,
      queryFn: () => {
        return fetchParentAirportDetails(parent_term_id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useParentAirportDocumentDetails };
